import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { UserCircle } from 'lucide-react';
import { auth, trackEvent } from '../firebase';
import { useAuth } from '../hooks/useAuth';

export default function Navbar() {
  const { user } = useAuth();

  const handleSignOut = () => {
    trackEvent('sign_out');
    signOut(auth).catch(console.error);
  };

  return (
    <nav className="flex items-center justify-between px-4 sm:px-6 py-4 bg-white border-b border-gray-200 sticky top-0 z-10">
      <Link to="/" className="text-lg font-extrabold text-brand-500 tracking-tight">
        PreLaunch Waitlist
      </Link>
      <div className="flex items-center gap-4">
        {user && (
          <>
            <span className="hidden sm:block text-sm text-gray-500 truncate max-w-[200px]">
              {user.email}
            </span>
            <Link
              to="/profile"
              title="Profile &amp; Settings"
              className="text-gray-400 hover:text-brand-500 transition-colors"
              onClick={() => trackEvent('profile_nav_clicked')}
            >
              <UserCircle className="h-5 w-5" />
            </Link>
            <button
              onClick={handleSignOut}
              className="text-sm font-semibold text-red-500 bg-transparent border-0 p-0 hover:underline"
            >
              Sign out
            </button>
          </>
        )}
      </div>
    </nav>
  );
}
